export default {"src":"/_next/static/media/downloadData.213d89ce.svg","height":650,"width":650};